import React from 'react';
import { cn } from '@/shared/utils/cn';

export const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({ className = '', ...props }) => (
  <input
    className={cn(
      'w-full bg-dark-input/80 backdrop-blur-sm border border-dark-border/30 text-dark-text text-base md:text-sm rounded-lg px-3 py-2',
      'hover:border-dark-border/30 hover:bg-dark-input/90',
      'focus-visible:ring-2 focus-visible:ring-brand-400/50 focus-visible:border-brand-500/60 focus-visible:bg-dark-input outline-none',
      'transition-all duration-200 ease-out',
      'placeholder:text-dark-muted/60',
      'min-h-[44px] md:min-h-0',
      'theme-dynamics:rounded-medium',
      'theme-dynamics:focus:shadow-elevation-1',
      'theme-dynamics:transition-fast',
      className
    )}
    {...props}
    data-testid='unknown-field-input'
    data-ux='field-edit'
    data-interaction-id='unknown-field-input' />
);
